import { Dialog as NDialog, type DialogProps as NDialogProps } from '@natera/material/lib/dialog'
import { useCallback, useState } from 'react'
import { cn } from '~/shared/lib/cn'
import './dialog.scss'

interface DialogProps extends Omit<NDialogProps, 'size'> {
  size?: 'sm' | 'md' | 'lg'
  dismissible?: boolean
}

export function Dialog({ className, size, onClose, dismissible = true, ...rest }: DialogProps) {
  const [isShaking, setIsShaking] = useState(false)

  const handleDialogOverlayClick = useCallback(() => {
    setIsShaking(true)
    setTimeout(() => {
      setIsShaking(false)
    }, 500)
  }, [])

  return (
    <NDialog
      {...rest}
      focusTrapOptions={{ skipInitialFocus: true, skipRestoreFocus: true }}
      className={cn(
        'c-dialog',
        {
          'c-dialog--small': size === 'sm',
          'c-dialog--md': size === 'md',
          'c-dialog--lg': size === 'lg',
          'c-dialog--shaking': isShaking,
        },
        className,
      )}
      onClose={dismissible ? onClose : handleDialogOverlayClick}
    />
  )
}
